import type Canvas from '../objects/Canvas';
import Device from '../objects/Device';
import type StylusDevice from './StylusDevice';
import ShapeDrawingBrush, {
  type CreateObjectOptions,
} from './ShapeDrawingBrush';

interface DeviceBrushOptions {
  deviceName: string;
}

class DeviceDrawingBrush extends ShapeDrawingBrush<DeviceBrushOptions> {
  deviceName: string;

  constructor(
    canvas: Canvas,
    stylus: StylusDevice,
    initialOptions: DeviceBrushOptions
  ) {
    super(canvas, stylus, initialOptions);
    this.deviceName = initialOptions.deviceName;
  }

  _createObject(options: CreateObjectOptions) {
    const controller = this.canvas.controller;

    const device = new Device({
      controller,
      ...controller.defaultsManager.for('device', this.deviceName),
      ...options,
      deviceName: this.deviceName,
    });
    return controller.addToCanvas(device);
  }
}

export default DeviceDrawingBrush;
